"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PdfDocumentPreview = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _ModalBase = require("../../../elements/modal-base/ModalBase");
var _LoadingBlock = require("../../../elements/loading-block/LoadingBlock");
var _react = _interopRequireWildcard(require("react"));
var _reactPdf = require("react-pdf");
var _classnames = _interopRequireDefault(require("classnames"));
var _pdfDocumentPreviewModule = _interopRequireDefault(require("./pdf-document-preview.module.scss"));
var _close = require("../../../assets/icons/close.svg");
var _useTranslation2 = require("../../../hooks/useTranslation/useTranslation");
_reactPdf.pdfjs.GlobalWorkerOptions.workerSrc = "//cdnjs.cloudflare.com/ajax/libs/pdf.js/".concat(_reactPdf.pdfjs.version, "/pdf.worker.min.js");
var PdfDocumentPreview = function PdfDocumentPreview(_ref) {
  var file = _ref.file,
    className = _ref.className,
    authorization = _ref.authorization,
    _ref$disableModalView = _ref.disableModalView,
    disableModalView = _ref$disableModalView === void 0 ? false : _ref$disableModalView;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isLoaded = _useState2[0],
    setIsLoaded = _useState2[1];
  var _useState3 = (0, _react.useState)(1),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    numberOfPages = _useState4[0],
    setNumberOfPages = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    isDetailsModalOpen = _useState6[0],
    setDetailsModalOpen = _useState6[1];
  var onClick = function onClick() {
    if (isLoaded && !disableModalView) {
      setDetailsModalOpen(true);
    }
  };
  var onDocumentLoadSuccess = function onDocumentLoadSuccess(_ref2) {
    var numPages = _ref2.numPages;
    setIsLoaded(true);
    setNumberOfPages(numPages);
  };
  var parsedFile = (0, _react.useMemo)(function () {
    return authorization ? {
      url: file,
      httpHeaders: {
        authorization: authorization
      }
    } : file;
  }, [authorization, file]);
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  var closePreview = function closePreview() {
    return setDetailsModalOpen(false);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactPdf.Document, {
    onLoadSuccess: onDocumentLoadSuccess,
    error: /*#__PURE__*/_react.default.createElement("div", {
      className: _pdfDocumentPreviewModule.default['pdf-document-preview__message'],
      "data-testid": "pdf-error"
    }, t('pdfDocumentPreview.pdfError')),
    className: (0, _classnames.default)(_pdfDocumentPreviewModule.default['pdf-document-preview'], className),
    file: parsedFile,
    loading: /*#__PURE__*/_react.default.createElement(_LoadingBlock.LoadingBlock, {
      className: _pdfDocumentPreviewModule.default['pdf-document-preview--loading'],
      "data-testid": "pdf-loading"
    }),
    noData: /*#__PURE__*/_react.default.createElement("div", {
      className: _pdfDocumentPreviewModule.default['pdf-document-preview__message']
    }, t('pdfDocumentPreview.empty')),
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_reactPdf.Page, {
    pageNumber: 1,
    loading: null
  })), /*#__PURE__*/_react.default.createElement(_ModalBase.ModalBase, {
    isOpen: isDetailsModalOpen,
    className: _pdfDocumentPreviewModule.default['pdf-document-preview__modal'],
    close: closePreview
  }, /*#__PURE__*/_react.default.createElement(_reactPdf.Document, {
    file: parsedFile,
    className: _pdfDocumentPreviewModule.default['pdf-document-preview__preview'],
    loading: null
  }, Array.from(new Array(numberOfPages), function (el, index) {
    return /*#__PURE__*/_react.default.createElement(_reactPdf.Page, {
      key: "page_".concat(index + 1),
      pageNumber: index + 1,
      loading: null
    });
  }))), isDetailsModalOpen && /*#__PURE__*/_react.default.createElement(_close.ReactComponent, {
    className: _pdfDocumentPreviewModule.default['pdf-document-preview__close-icon'],
    onClick: closePreview,
    "data-testid": "close-icon"
  }));
};
exports.PdfDocumentPreview = PdfDocumentPreview;